import { render, staticRenderFns } from "./FittingAnswerWrite.vue?vue&type=template&id=686f9576&"
import script from "./FittingAnswerWrite.vue?vue&type=script&lang=js&"
export * from "./FittingAnswerWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports